import assetUtils from 'app-lib/assetUtils'
import { TradeType as TradeT } from 'app-lib/dexSelector/types'
import { AnyProvider } from 'app-lib/providerUtils'
import tradeUtils from 'app-lib/tradeUtils'
import IBorrowedFundsState from 'bzx-common/src/domain/IBorrowedFundsState'
import { ITradeRequest, PositionType } from 'bzx-common/src/domain/trade.types'
import oracleApi from './apis/oracleApi'
import dexSelector from './dexSelector'

export async function getSwapDataForNewPosition(provider: AnyProvider, request: ITradeRequest) {
  if (!request.dex) {
    throw new Error('Unspecified dex')
  }
  const chainId = provider.currentChainId
  const { deposit, src, dest, loaned, leverage } = tradeUtils.getTradeTokens(chainId, request)
  let depositAmount = request.amount.times(10 ** deposit.decimals).times(leverage)

  if (deposit.asset !== loaned.asset) {
    const swapPrice = await oracleApi.getSwapRateNew(provider, deposit.asset, loaned.asset)
    depositAmount = depositAmount.times(swapPrice).integerValue()
  }
  const payloadInputData = {
    srcToken: src.asset,
    destToken: dest.asset,
    amountUsed: depositAmount,
    direction: TradeT.EXACT_INPUT,
  }
  return dexSelector.getTradePayload(provider, payloadInputData, request.dex)
}

export async function getSwapDataForClosingPosition(
  provider: AnyProvider,
  request: ITradeRequest,
  loan: IBorrowedFundsState
) {
  if (!request.dex) {
    throw new Error('Unspecified dex')
  }
  const chainId = provider.currentChainId
  const { positionType, amount } = request
  const { loaned, collateral, src, dest } = tradeUtils.getTradeTokens(chainId, request)
  const isLong = positionType === PositionType.LONG

  if (!request.returnTokenIsCollateral) {
    const depositAmount = amount.times(10 ** collateral.decimals)
    const payloadInputData = {
      srcToken: src.asset,
      destToken: dest.asset,
      amountUsed: depositAmount,
      direction: TradeT.EXACT_INPUT,
    }
    return dexSelector.getTradePayload(provider, payloadInputData, request.dex)
  }

  const { loanData } = loan
  const depositAmount = isLong
    ? amount.times(10 ** collateral.decimals)
    : amount
        .times(10 ** assetUtils.getDecimals(provider.currentChainId, loaned.asset))
        .times(loanData.collateral)
        .div(loanData.principal)

  const amountOutNeeded = loanData.principal.times(depositAmount).div(loanData.collateral)

  const payloadInputData = {
    srcToken: src.asset,
    destToken: dest.asset,
    amountUsed: amountOutNeeded,
    direction: TradeT.EXACT_OUTPUT,
    amountsInMax: depositAmount.times(1.003).gt(loanData.collateral)
      ? loanData.collateral
      : depositAmount.times(1.003).integerValue(),
  }
  return dexSelector.getTradePayload(provider, payloadInputData, request.dex)
}

export default {
  getSwapDataForNewPosition,
  getSwapDataForClosingPosition,
}
